import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=4bd56bc0&scoped=true&"
import script from "./contact.vue?vue&type=script&lang=js&"
export * from "./contact.vue?vue&type=script&lang=js&"
import style0 from "./contact.css?vue&type=style&index=0&id=4bd56bc0&prod&scoped=true&lang=css&"
import style1 from "./contact.vue?vue&type=style&index=1&id=4bd56bc0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd56bc0",
  null
  
)

export default component.exports